import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nProvider } from "./languages/providers/I18nProvider";
import { ThemeProvider } from "./providers/ThemeContext";
import { MuiRtlProvider } from "./providers/MuiRtlProvider";

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <I18nProvider>
          <MuiRtlProvider>
            <App />
          </MuiRtlProvider>
        </I18nProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById("root") as HTMLElement;

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(app);
}

reportWebVitals();
